import React from 'react';
import TabBadge from '../components/shared/TabBadge';
import { useCasualPage } from './CasualsAvailability';

/**
 * Tab placeholders for the casual pages — the `placeholder` on an InnerTabsd /
 * InnerTabsm entry. Each reads the shared CasualsAvailabilityProvider, so the
 * number is the one the tab itself shows. Nothing renders until the data has loaded.
 *
 *   My Availability / Mine   days still open on My Availability
 *   Assigned Jobs / Jobs     jobs waiting for an answer (Pending, not yet expired)
 *   Jobs Completed / Done    jobs marked done
 *   Messages                 bell, unread job messages
 */
const loaded = (s) => s && !(s.entriesLoading && s.entries.length === 0 && s.jobs.length === 0);

export const AvailableDaysBadge = () => {
  const s = useCasualPage();
  if (!loaded(s)) return null;
  return <TabBadge title="Days you are available">{s.openDays}</TabBadge>;
};

export const PendingJobsBadge = () => {
  const s = useCasualPage();
  if (!loaded(s)) return null;
  return <TabBadge title="Jobs waiting for your answer">{s.pendingTotal}</TabBadge>;
};

export const DoneJobsBadge = () => {
  const s = useCasualPage();
  if (!loaded(s)) return null;
  return <TabBadge title="Jobs done">{s.doneTotal}</TabBadge>;
};

export const CasualMessagesBellBadge = () => {
  const s = useCasualPage();
  if (!s) return null;
  return <TabBadge bell unread={s.unreadTotal} />;
};
